export default __webpack_public_path__ + "static/media/Web-Cover_2024.277ba9b2.jpg";